import { Badge, Box } from '@chakra-ui/react'
import CustomTooltip from 'BrokerTsLib/src/components/CustomTooltip'
import { getOfferTypeColor, getOfferTypeName, getOfferTypeShortName, OfferType } from 'BrokerTsLib/src/dtos'
import type { InsuranceParamsType } from 'BrokerTsLib/src/enums'
import { getInsuranceParamsTypeColor, getInsuranceParamsTypeName, getInsuranceParamsTypeShortName } from 'BrokerTsLib/src/enums'
import { isIn } from 'BrokerTsLib/src/Utils/comparisonUtils'

export const InsuranceParamsTypeBadge = ({ type, offerType }: { type: InsuranceParamsType, offerType: OfferType }) => {
  const useOfferType = isIn(offerType, OfferType.ZnacnovePojisteniMazda, OfferType.ZnacnovePojisteniSubaru, OfferType.ZnackovePojisteniKia)

  const [bgColor, fgColor] = (useOfferType ? getOfferTypeColor(offerType) : getInsuranceParamsTypeColor(type)) ?? ['primary.50', 'primary.500']
  const name = useOfferType ? getOfferTypeName(offerType) : getInsuranceParamsTypeName(type)
  const shortName = useOfferType ? getOfferTypeShortName(offerType) : getInsuranceParamsTypeShortName(type)

  return <Box justifySelf='start'>
    <CustomTooltip label={name} hasArrow>
      <Badge fontSize='md' fontWeight='600' bg={bgColor} color={fgColor} variant='subtle' borderRadius={6} >{shortName}</Badge>
    </CustomTooltip>
  </Box>
}